import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DeleteModalComponent } from "./delete-modal.component";

@NgModule({
  declarations: [DeleteModalComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [DeleteModalComponent],
})
export class DeleteModalModule {}
